<div #element>
  <mship-launch-menu [launchMenuConfig]="launchMenuConfig()" (whenOpenApp)="openApp($event)">
    <p-button
      icon="pi pi-plus"
      [text]="true"
      [title]="'serviceDlp.headerActions.openInNewWindow' | translate"
    ></p-button>
  </mship-launch-menu>
</div>
